import type { FC } from 'react';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import {
  BrandKey,
  TagType,
} from '../../../../../../../../__generated__/queries-web';
import { useSearchEnabledTagsGetter } from '../../../../../../../../apollo/queries/getEnabledTags.web.graphql';
import { getTagsAutoCompleteList } from '../../../../../../../../components/Tags/utils';
import type { CategoryFormSectionBoardTag, SectionForm } from '../../types';
import { useEditSection } from '../../useEditSection';
import { TabMultiselect } from '../TabMultiselect';
import {
  BOARD_TAB_TAGS_LABEL,
  BOARD_TAB_TAGS_MAX_QUANTITY,
  BOARD_TAB_TAGS_SEARCH_PLACEHOLDER,
} from '../TabMultiselect/constants';
import type { BoardProps } from '../';

type BoardTagsProps = Pick<BoardProps, 'id' | 'tags'>;

export const BoardTags: FC<BoardTagsProps> = ({ id, tags }) => {
  const { brandKey } = useParams<{ brandKey: BrandKey }>();
  const { handlers } = useEditSection(id);
  const searchTags = useSearchEnabledTagsGetter();

  const handleTagsChange = useCallback(
    (newTags: CategoryFormSectionBoardTag[]) => {
      handlers.handleSectionChange({
        fieldName: 'tags' as keyof SectionForm,
        value: newTags,
      });
    },
    [handlers],
  );

  const fetchList = useCallback(
    (search: string) =>
      searchTags({
        search,
        brandKey,
        type: [TagType.Tag, TagType.Destination],
      }).then((sortedTagList = []) =>
        getTagsAutoCompleteList(sortedTagList, tags, brandKey),
      ),
    [brandKey, searchTags, tags],
  );

  return (
    <TabMultiselect
      chipVariant="tag"
      fetchList={fetchList}
      isSearchMandatory
      items={tags}
      label={BOARD_TAB_TAGS_LABEL}
      maxQuantity={BOARD_TAB_TAGS_MAX_QUANTITY}
      onChange={handleTagsChange}
      searchPlaceholder={BOARD_TAB_TAGS_SEARCH_PLACEHOLDER}
    />
  );
};
